export const blogData = [
{
  slug: "gestion-publica-gobernanza",
  title: "Áreas de especialización",
  description: "Transformamos conocimiento en una gestión pública más eficiente, transparente e innovadora.",
  pubDate: "2026-07-10",
  author: "Instituto de Gerencia Intercontinental",
  image: "/Img/IGCescuela.png",
  content: `
    <h2>GESTIÓN PÚBLICA, GOBERNANZA Y MODERNIZACIÓN DEL ESTADO</h2>
    <h2>Transformamos conocimiento en una gestión pública más eficiente, transparente e innovadora.</h2>
    <p>Fortalecer las capacidades de los servidores públicos es uno de los pilares fundamentales para el progreso del Estado. Nuestra Escuela brinda programas especializados que combinan el marco normativo actual, la gestión estratégica, la modernización institucional y la aplicación práctica de los Sistemas Administrativos del Estado.</p>
    <p>A lo largo de nuestra formación, los participantes adquieren herramientas para planificar, administrar recursos del Estado, dirigir procesos, implementar mejoras organizativas y aportar a una gestión orientada a resultados, fortaleciendo así la eficiencia de las instituciones y generando valor público para la ciudadanía.</p>
    <h3>Líneas de Especialización</h3>
    <ul>
      <li>* Gestión Pública</li>
      <li>* Modernización de la Gestión Pública</li>
      <li>* Sistemas Administrativos del Estado</li>
      <li>* Planeamiento Estratégico</li>
      <li>* Gestión por Resultados</li>
      <li>* Gobierno Digital</li>
      <li>* Integridad y Ética Pública</li>
      <li>* Derecho Administrativo</li>
      <li>* Control Gubernamental</li>
      <li>* Recursos Humanos</li>
      <li>* Presupuesto Público</li>
      <li>* Tesorería</li>
      <li>* Contabilidad Gubernamental</li>
      <li>* Endeudamiento Público</li>
      <li>* Sistema Nacional de Abastecimiento</li>
      <li>* Contrataciones del Estado</li>
      <li>* SIGA</li>
      <li>* SIAF SP-Web</li>
      <li>* SEACE</li>
      <li>* Invierte.pe</li>
    </ul>
  `
},

{
  slug: "inteligencia-artificial",
  title: "Inteligencia Artificial, Automatización y Productividad Digital",
  description: "La revolución tecnológica ya comenzó. Aprende hoy las herramientas que definirán el trabajo del futuro.",
  pubDate: "2026-07-10",
  author: "Instituto de Gerencia Intercontinental",
  image: "/Img/IGCescuela.png",
  content: `
    <h2>La revolución tecnológica ya comenzó. Aprende hoy las herramientas que definirán el trabajo del futuro.</h2>
    <p>La Inteligencia Artificial está cambiando la forma en que las organizaciones planifican, analizan información, automatizan procesos y toman decisiones. Nuestra oferta académica permite a profesionales, empresas y entidades públicas incorporar soluciones basadas en IA para aumentar la productividad, reducir tiempos operativos y potenciar la innovación.</p>
    <p>Nuestros programas están diseñados para desarrollar competencias prácticas mediante el uso de plataformas líderes a nivel mundial, integrando casos reales y metodologías de aprendizaje aplicadas al entorno laboral.</p>
    <h3>Líneas de Especialización</h3>
    <ul>
      <li>* Inteligencia Artificial Generativa</li>
      <li>* ChatGPT Profesional</li>
      <li>* Microsoft Copilot</li>
      <li>* Google Gemini</li>
      <li>* Claude AI</li>
      <li>* Perplexity AI</li>
      <li>* Ingeniería de Prompts</li>
      <li>* Automatización Inteligente</li>
      <li>* IA aplicada a la Gestión Pública</li>
      <li>* IA para Recursos Humanos</li>
      <li>* IA para Finanzas</li>
      <li>* IA para Marketing</li>
      <li>* IA para Educación</li>
      <li>* IA para Investigación</li>
      <li>* IA para Elaboración de Informes</li>
      <li>* IA para Elaboración de Presentaciones</li>
      <li>* Ética y Gobernanza de la Inteligencia Artificial</li>
    </ul>
  `
},

{
  slug: "excel-analitica",
  title: "Excel, Analítica de Datos y Automatización Empresarial",
  description: "Domina la información, automatiza procesos y convierte los datos en decisiones estratégicas.",
  pubDate: "2026-07-10",
  author: "Instituto de Gerencia Intercontinental",
  image: "/Img/IGCescuela.png",
  content: `
    <h2>Domina la información, automatiza procesos y convierte los datos en decisiones estratégicas.</h2>
    <p>En un entorno donde la información es uno de los principales activos de las organizaciones, dominar Microsoft Excel representa una ventaja competitiva para cualquier profesional. Nuestra Escuela desarrolla programas especializados que permiten automatizar tareas, analizar grandes volúmenes de datos y diseñar reportes ejecutivos mediante herramientas avanzadas de análisis.</p>
    <p>La formación combina ejercicios prácticos, simulaciones y casos aplicados para fortalecer la capacidad analítica y la toma de decisiones basada en datos.</p>
    <h3>Líneas de Especialización</h3>
    <ul>
      <li>* Excel Básico</li>
      <li>* Excel Intermedio</li>
      <li>* Excel Avanzado</li>
      <li>* Excel Profesional</li>
      <li>* Dashboard Ejecutivos</li>
      <li>* Tablas Dinámicas</li>
      <li>* Funciones Avanzadas</li>
      <li>* Power Query</li>
      <li>* Power Pivot</li>
      <li>* Automatización con Macros</li>
      <li>* VBA</li>
      <li>* Excel Financiero</li>
      <li>* Excel aplicado a Recursos Humanos</li>
      <li>* Excel para Logística</li>
      <li>* Excel para Gestión Pública</li>
      <li>* Indicadores de Gestión (KPI)</li>
    </ul>
  `
},

{
  slug: "ofimatica-colaborativa",
  title: "Ofimática y Herramientas Colaborativas",
  description: "Incrementa tu productividad dominando las herramientas digitales más utilizadas en el entorno profesional.",
  pubDate: "2026-07-10",
  author: "Instituto de Gerencia Intercontinental",
  image: "/Img/IGCescuela.png",
  content: `
    <h2>Incrementa tu productividad dominando las herramientas digitales más utilizadas en el entorno profesional.</h2>
    <p>El manejo eficiente de las aplicaciones de Microsoft Office es una competencia esencial para cualquier organización. Nuestros programas están orientados a desarrollar habilidades para elaborar documentos profesionales, diseñar presentaciones de alto impacto, gestionar información y potenciar el trabajo colaborativo mediante soluciones en la nube.</p>
    <p>La capacitación incorpora metodologías prácticas orientadas a optimizar el desempeño laboral y mejorar la eficiencia en el manejo de la información.</p>
    <h3>Líneas de Especialización</h3>
    <ul>
      <li>* Microsoft Word</li>
      <li>* Microsoft Excel</li>
      <li>* Microsoft PowerPoint</li>
      <li>* Microsoft Outlook</li>
      <li>* Microsoft Teams</li>
      <li>* Microsoft OneDrive</li>
      <li>* Microsoft Access</li>
      <li>* Microsoft Forms</li>
      <li>* Microsoft Project</li>
    </ul>
  `
},

{
  slug: "business-intelligence",
  title: "Business Intelligence, Power BI y Visualización de Datos",
  description: "Convierte los datos en conocimiento y el conocimiento en decisiones inteligentes.",
  pubDate: "2026-07-10",
  author: "Instituto de Gerencia Intercontinental",
  image: "/Img/IGCescuela.png",
  content: `
    <h2>Convierte los datos en conocimiento y el conocimiento en decisiones inteligentes.</h2>
    <p>Las organizaciones exitosas basan sus decisiones en información confiable y oportunamente analizada. Nuestros programas especializados permiten diseñar modelos analíticos, construir indicadores de desempeño y desarrollar tableros interactivos que facilitan el monitoreo y la gestión estratégica mediante herramientas de Business Intelligence.</p>
    <h3>Líneas de Especialización</h3>
    <ul>
      <li>* Power BI</li>
      <li>* Modelado de Datos</li>
      <li>* DAX</li>
      <li>* Power Query</li>
      <li>* Dashboards Ejecutivos</li>
      <li>* Indicadores Estratégicos</li>
      <li>* Business Intelligence</li>
      <li>* Storytelling con Datos</li>
      <li>* Analítica Empresarial</li>
    </ul>
  `
},

{
  slug: "transformacion-digital",
  title: "Transformación Digital, Gobierno Digital e Innovación",
  description: "La innovación es el motor que impulsa organizaciones más ágiles, conectadas y competitivas.",
  pubDate: "2026-07-10",
  author: "Instituto de Gerencia Intercontinental",
  image: "/Img/IGCescuela.png",
  content: `
    <h2>La innovación es el motor que impulsa organizaciones más ágiles, conectadas y competitivas.</h2>
    <p>La transformación digital representa un proceso integral que permite modernizar la gestión institucional mediante la incorporación de tecnologías, automatización de procesos y nuevos modelos de trabajo. Nuestra oferta académica desarrolla competencias para liderar procesos de innovación y digitalización tanto en el sector público como privado.</p>
    <h3>Líneas de Especialización</h3>
    <ul>
      <li>* Gobierno Digital</li>
      <li>* Transformación Digital</li>
      <li>* Gestión Documental</li>
      <li>* Firma Digital</li>
      <li>* Firma Electrónica</li>
      <li>* Mesa de Partes Virtual</li>
      <li>* Automatización de Procesos</li>
      <li>* Ciberseguridad</li>
      <li>* Protección de Datos Personales</li>
      <li>* Innovación Organizacional</li>
    </ul>
  `
},

{
  slug: "gestion-empresarial",
  title: "Gestión Empresarial, Dirección y Calidad",
  description: "Fortalecemos líderes capaces de gestionar organizaciones sostenibles, competitivas y orientadas a resultados.",
  pubDate: "2026-07-10",
  author: "Instituto de Gerencia Intercontinental",
  image: "/Img/IGCescuela.png",
  content: `
    <h2>Fortalecemos líderes capaces de gestionar organizaciones sostenibles, competitivas y orientadas a resultados.</h2>
    <p>La gestión empresarial requiere profesionales con visión estratégica, capacidad de liderazgo y dominio de herramientas modernas de administración. Nuestros programas integran conocimientos de dirección, finanzas, calidad, gestión por procesos y mejora continua para impulsar el crecimiento y la competitividad de las organizaciones.</p>
    <h3>Líneas de Especialización</h3>
    <ul>
      <li>* Administración</li>
      <li>* Finanzas</li>
      <li>* Recursos Humanos</li>
      <li>* Marketing</li>
      <li>* Planeamiento Estratégico</li>
      <li>* Gestión Comercial</li>
      <li>* Gestión por Procesos</li>
      <li>* Gestión de la Calidad</li>
      <li>* ISO 9001</li>
      <li>* ISO 21001</li>
      <li>* ISO 37001</li>
      <li>* Gestión de Proyectos</li>
    </ul>
  `
},

{
  slug: "liderazgo-habilidades",
  title: "Liderazgo, Habilidades Directivas y Desarrollo Profesional",
  description: "El conocimiento técnico abre oportunidades; el liderazgo permite transformar organizaciones.",
  pubDate: "2026-07-10",
  author: "Instituto de Gerencia Intercontinental",
  image: "/Img/IGCescuela.png",
  content: `
    <h2>El conocimiento técnico abre oportunidades; el liderazgo permite transformar organizaciones.</h2>
    <p>Las competencias humanas se han convertido en un factor determinante para el éxito profesional. Nuestra Escuela desarrolla programas orientados a fortalecer el liderazgo, la comunicación, la inteligencia emocional y las habilidades gerenciales, permitiendo a los participantes desenvolverse con éxito en entornos de alta exigencia y constante cambio.</p>
    <h3>Líneas de Especialización</h3>
    <ul>
      <li>* Liderazgo</li>
      <li>* Comunicación Efectiva</li>
      <li>* Inteligencia Emocional</li>
      <li>* Trabajo en Equipo</li>
      <li>* Negociación</li>
      <li>* Gestión del Tiempo</li>
      <li>* Resolución de Problemas</li>
      <li>* Pensamiento Crítico</li>
      <li>* Atención al Cliente</li>
      <li>* Servicio al Ciudadano</li>
      <li>* Oratoria</li>
      <li>* Redacción Profesional</li>
      <li>* Gestión del Cambio</li>
      <li>* Innovación</li>
      <li>* Coaching Ejecutivo</li>
    </ul>
  `
},

{
  slug: "por-que-elegirnos",
  title: "¿Por qué elegirnos?",
  description: "Descubre por qué nuestra institución es la mejor opción para tu formación profesional.",
  pubDate: "2026-07-10",
  author: "Instituto de Gerencia Intercontinental",
  image: "/Img/IGCescuela.png",
  content: `
    <h2>¿Por qué elegirnos?</h2>
    <p>En un entorno donde el conocimiento evoluciona constantemente, nuestra institución ofrece una propuesta formativa integral que combina <strong>experiencia académica, innovación tecnológica y enfoque práctico</strong>.</p>
    <p>Nuestros programas están diseñados para responder a las necesidades reales del mercado laboral, integrando metodologías activas, análisis de casos, herramientas digitales y contenidos permanentemente actualizados.</p>
    <p>Creemos en una formación que transforma personas y organizaciones. Por ello, promovemos el desarrollo de competencias técnicas, digitales y gerenciales que permitan afrontar con éxito los retos de la administración pública, la gestión empresarial y la transformación digital.</p>
    <p>Nuestro compromiso es formar profesionales capaces de generar valor, liderar procesos de mejora continua y contribuir al desarrollo de instituciones más eficientes, innovadoras y orientadas a resultados.</p>
  `
}

];